import { lazy, ComponentType } from "react";
import { reloadWithFreshAssets } from "@/lib/chunk-recovery";

/**
 * Após um novo deploy, o index.html em cache pode apontar para ficheiros JS
 * antigos que já não existem no servidor. Nesse caso recarregamos com um
 * parâmetro único para ignorar caches intermédias e obter o HTML atual.
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const module = await factory();

      // Vite devolve `undefined` quando um listener de vite:preloadError
      // impede o comportamento padrão. Sem esta validação, React tenta ler
      // `module.default` e apresenta o erro pouco informativo undefined.default.
      if (!module || typeof module.default === "undefined") {
        throw new Error("O módulo da aplicação não foi carregado corretamente");
      }

      return module;
    } catch (error) {
      if (reloadWithFreshAssets()) {
        return { default: (() => null) as unknown as T };
      }
      throw error;
    }
  });
}
